__turbopack_context__.v({
  "actionButton": "FocusAreaHeader-module-scss-module__lxI2Aq__actionButton",
  "actions": "FocusAreaHeader-module-scss-module__lxI2Aq__actions",
  "description": "FocusAreaHeader-module-scss-module__lxI2Aq__description",
  "disabled": "FocusAreaHeader-module-scss-module__lxI2Aq__disabled",
  "header": "FocusAreaHeader-module-scss-module__lxI2Aq__header",
  "right": "FocusAreaHeader-module-scss-module__lxI2Aq__right",
  "title": "FocusAreaHeader-module-scss-module__lxI2Aq__title",
  "titleContainer": "FocusAreaHeader-module-scss-module__lxI2Aq__titleContainer",
  "titleSection": "FocusAreaHeader-module-scss-module__lxI2Aq__titleSection",
  "visionLink": "FocusAreaHeader-module-scss-module__lxI2Aq__visionLink",
});
